export default __webpack_public_path__ + "6fd10ffdf7ae8846410ab15787943cf5.svg";